import { useCallback } from 'react';
import { Link } from '@alf/uikit';
import { LOG_ACTIONS, logAction, useLogAmplitude } from '@namespace/analytics';
import { useOpenChat } from '@namespace/chats';
import { useGeneralRoutes } from '@namespace/cms';
import { LocalizedLink, useI18n } from '@namespace/i18n';

import styles from './index.module.css';

export const GenericLink = ({
  itemTitle,
  link,
  linkClass,
  linkCustomClass,
  isTargetBlank,
  analyticAction,
  entryPoint
}) => {
  const { t } = useI18n();
  const logAmplitude = useLogAmplitude();
  const { promotions } = useGeneralRoutes();
  const { openChat } = useOpenChat();

  const handleClickOnLink = useCallback(() => {
    logAction(LOG_ACTIONS.MENU_CLICK, {
      label: itemTitle,
      location: entryPoint,
      link
    });
    if (!analyticAction) {
      return;
    }

    logAmplitude({
      actionName: LOG_ACTIONS.SECTION_OPEN,
      attributes: { entry_point: entryPoint, section_open: link },
      isMatchPath: false,
      isMatchSection: true,
      additionalRoutes: { promotions }
    });
  }, [analyticAction, entryPoint, link, logAmplitude, itemTitle]);

  if (link === 'openChat') {
    return (
      <Link
        onClick={(e) => {
          e.preventDefault();
          openChat();
        }}
        to="/"
        Component={LocalizedLink}
        className={`${styles.link} ${linkCustomClass}`}
        intent="secondary"
        size="s"
        breed="R"
      >
        {t(itemTitle)}
      </Link>
    );
  }

  return (link || '').includes('https') || isTargetBlank ? (
    <a
      onClick={handleClickOnLink}
      className={`${styles.link} ${linkClass}`}
      target="_blank"
      rel="noopener noreferrer"
      href={link}
    >
      {t(itemTitle)}
    </a>
  ) : (
    <Link
      onClick={handleClickOnLink}
      to={`${link}` || ''}
      Component={LocalizedLink}
      className={`${styles.link} ${linkCustomClass}`}
      intent="secondary"
      size="s"
      breed="R"
    >
      {t(itemTitle)}
    </Link>
  );
};
